import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

const HomeNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  // Scroll behavior
  const handleScroll = () => {
    const offset = window.scrollY;
    setIsScrolled(offset > 300);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav className={`home-navbar navbar navbar-dark navbar-expand-md fixed-top w-100 ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container-xxl">
       
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#main-nav"
          aria-controls="main-nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end align-center" id="main-nav">
          <ul className="navbar-nav">
            
          <li className="nav-item mx-3 mb-2">
              <NavLink to="/Home" style={({ isActive }) => ({
                textDecoration: "none",
                color: isActive ? "#c2b697" : "#fff",
              })}>
               Anasayfa
              </NavLink>
            </li>

            {/* Referanslar Link */}
            <li className="nav-item mx-3 mb-0">
              <NavLink to="/Hizmetler" style={({ isActive }) => ({
                textDecoration: "none",
                color: isActive ? "#c2b697" : "#fff",
              })}>
                Hizmetler
              </NavLink>
            </li>

            {/* Hizmetler Link */}
            <li className="nav-item mx-3 mb-0">
              <NavLink to="/Blog" style={({ isActive }) => ({
                textDecoration: "none",
                color: isActive ? "#c2b697" : "#fff",
              })}>
                Blog
              </NavLink>
            </li>

            {/* Blog Link */}
            <li className="nav-item mx-3 mb-0">
              <NavLink to="/Danismanlik" style={({ isActive }) => ({
                textDecoration: "none",
                color: isActive ? "#c2b697" : "#fff",
              })}>
                Danışmanlık
              </NavLink>
            </li>

            <li className="nav-item mx-3 mb-2">
                  <NavLink
                    to="/Bilgi"
                    style={({ isActive }) => ({
                      textDecoration: "none",
                      color: isActive ? "#c2b697" : "#fff",
                      borderBottom: isActive ? "1px solid #c2b697" : "none",
                      paddingBottom: isActive ? "5px" : "0",
                    })}
                  >
                   Yararlı Bilgiler
                  </NavLink>
                </li>
            {/* İletişim Link */}
            <li className="nav-item mx-3 mb-0">
              <NavLink to="/iletisim" style={({ isActive }) => ({
                textDecoration: "none",
                color: isActive ? "#c2b697" : "#fff",
              })}>
                İletişim
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default HomeNavbar;
